import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";
import closeSvg from "@app/neva/assets/svg/close.svg";
import "./launcherPopup.scss";
import Svg from "@natera/material/lib/svg";

export interface LauncherPopupProps {
  text: string;
  handleSubmit: () => void;
  handleClose: () => void;
}

const messages = defineMessages({
  widgetLauncherPopupButton: {
    id: "widgetLauncherPopupButton",
    defaultMessage: "Dismiss welcome message",
  },
});

const LauncherPopup: FC<LauncherPopupProps> = ({
  text,
  handleSubmit,
  handleClose,
}) => {
  const intl = useIntl();
  return (
    <div className="launcher-popup__container" data-testid="launcher-popup">
      <button
        className="launcher-popup__close-icon-button"
        aria-label={intl.formatMessage(messages.widgetLauncherPopupButton)}
        onClick={handleClose}
      >
        <Svg
          className="launcher-popup__close_icon"
          content={closeSvg}
          role="img"
        />
      </button>
      <div className="launcher-popup__text-container" onClick={handleSubmit}>
        <p className="launcher-popup__text">{text}</p>
      </div>
    </div>
  );
};

export default LauncherPopup;
